import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import corporateDataService from "services/corporate";

const initialState = {
  transactions: {
    items: [],
    totalCount: 0,
  },
  getTransactions: {
    status: "idle",
    error: false,
  },
};

export const getCorporateTransactionsAsync = createAsyncThunk(
  "corporate/getCorporateTransactions",
  async ({ corporateId, params }, { rejectWithValue }) => {
    try {
      const res = await corporateDataService.getTransactions(
        corporateId,
        params
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const corporateSlice = createSlice({
  name: "corporate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCorporateTransactionsAsync.pending, (state) => {
        state.getTransactions.status = "loading";
        state.getTransactions.error = false;
      })
      .addCase(getCorporateTransactionsAsync.fulfilled, (state, action) => {
        state.getTransactions.status = "idle";
        state.transactions = action.payload;
      })
      .addCase(getCorporateTransactionsAsync.rejected, (state, action) => {
        state.getTransactions.status = "failed";
        state.getTransactions.error = action?.payload?.messageText;
      });
  },
});

const { reducer } = corporateSlice;

export default reducer;
